import React from 'react';

// Two column wizard step: preview on the left, editable form on the right.
export default function DataStepLayout({ title, deleteButton, preview, children }) {
  return (
    <div className="data-step-layout">
      {preview}
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">{title}</h3>
          {deleteButton}
        </div>
        {children}
      </div>
    </div>
  );
}
